import {NgModule} from '@angular/core';
import {PartnerWithUsForBenefitsComponent} from './partner-with-us-for-benefits.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [PartnerWithUsForBenefitsComponent],
    imports: [CommonModule],
    exports: [PartnerWithUsForBenefitsComponent]
})
export class PartnerWithUsForBenefitsModule {
}
